import { useAccount, useConnect, useDisconnect } from "wagmi";
import { injected } from "wagmi/connectors";

/**
 * Decorative wallet connect. Implies the production architecture; doesn't sign
 * anything or trigger transactions. If MetaMask isn't installed, falls back
 * to a disabled state.
 */
export default function WalletButton() {
  const { address, isConnected } = useAccount();
  const { connect, isPending } = useConnect();
  const { disconnect } = useDisconnect();

  if (isConnected && address) {
    const short = `${address.slice(0, 6)}...${address.slice(-4)}`;
    return (
      <button
        onClick={() => disconnect()}
        className="font-mono text-sm border border-white/30 px-3 py-2 rounded hover:bg-white/10"
      >
        {short}
      </button>
    );
  }

  return (
    <button
      onClick={() => connect({ connector: injected() })}
      disabled={isPending}
      className="font-mono text-sm bg-white text-black px-3 py-2 rounded hover:bg-white/90 disabled:opacity-50"
    >
      {isPending ? "connecting..." : "connect wallet"}
    </button>
  );
}
